<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: ITAT Time
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />

      <!--Alert Modal-->
    	<vs-popup 
        color="danger"
        :title="alertModal.content.header"
        @accept="CloseModal('AlertModal')"
        @close="CloseModal('AlertModal')"
        accept-text="Close"
        button-cancel="none"
        :active="alertModal.show">
        <div class="con-exemple-prompt">
        <!-- Enter your first and last name to <b>continue</b>. -->
        <p>{{alertModal.content.body[0]}}</p>
        <br/>
        <vs-textarea class="mt-2" disabled v-model="alertModal.content.details" height="10rem"></vs-textarea>


        <vs-button color="danger" class="float-right" @click="CloseModal('AlertModal')">Close</vs-button>

        </div>
      </vs-popup>

      <!--Settings Modal-->
    	<vs-prompt 
        color="primary"
        :title="settingsModal.content.header"
        @cancel="CloseModal('SettingsModal')"
        @accept="CloseModal('SettingsModal')"
        @close="CloseModal('SettingsModal')"
        :active="settingsModal.show">
        <div class="con-exemple-prompt">
        <!-- Enter your first and last name to <b>continue</b>. -->
        <p>{{settingsModal.content.body[0]}}</p>

        </div>
      </vs-prompt>


  </div>
</template>
 

<script>
import themeConfig from '@/../themeConfig.js'

export default {
  data () {
    return {
      vueAppClasses: []
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    updateBodyModalClass () {
      const hasDialog = document.querySelector('.con-vs-dialog')
      const popups = document.querySelectorAll('.con-vs-popup')
      const hasVisiblePopup = Array.from(popups).some(el => {
        const s = window.getComputedStyle(el)
        return s.display !== 'none' && s.visibility !== 'hidden'
      })
      if (hasDialog || hasVisiblePopup) {
        document.body.classList.add('body-modal-open')
      } else {
        document.body.classList.remove('body-modal-open')
      }
    },
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    CloseModal (modalName) {
      this.$store.dispatch('ActionOpenCloseModal', {'modal':modalName, 'show':false}, {root:true})
    }
  },
  computed: {
    settingsModal () {
      return this.$store.getters.GetSettingsModal
    },
    alertModal () {
      return this.$store.getters.GetAlertModal
    }
  },
  mounted () {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    // **********************************************************************************************************************
    // This is to detect open modals and disable scrolling on the body when a modal is opened
    // but has a major performance impact, so we're not using it for now
    // **********************************************************************************************************************
    // let modalClassRaf = null
    // this._modalObserver = new MutationObserver(() => {
    //   if (modalClassRaf) return
    //   modalClassRaf = requestAnimationFrame(() => {
    //     this.updateBodyModalClass()
    //     modalClassRaf = null
    //   })
    // })
    // this._modalObserver.observe(document.body, {
    //   childList: true,
    //   subtree: true,
    //   attributes: true,
    //   attributeFilter: ['style', 'class']
    // })
    // this.updateBodyModalClass()
  },
  async created () {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    if (this._modalObserver) {
      this._modalObserver.disconnect()
    }
    document.body.classList.remove('body-modal-open')
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>

<style lang="scss">
.align-center{
  align-items: center;
}

body.body-modal-open {
  overflow: hidden;
}

.con-vs-dialog.z-modal-2{
  z-index: 53010 !important;
}

.con-vs-dialog.z-modal-2 .vs-dialog {
  z-index: 53011 !important;
}

.con-vs-dialog.z-modal-3{
  z-index: 54010 !important;
}

.con-vs-dialog.z-modal-3 .vs-dialog {
  z-index: 54011 !important;
}
</style>